module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"Shortcuts":"Клавиатурные сочетания"}}')
  delete Component.options._Ctor
}
